import React from 'react';

// Care instruction icons as SVG components
const Icons = {
  // 1. Temperature - thermometer with 30°
  temperature: (
    <svg viewBox="0 0 40 40" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8">
      <rect x="14" y="6" width="12" height="24" rx="6" />
      <circle cx="20" cy="26" r="4" fill="currentColor" />
      <line x1="20" y1="12" x2="20" y2="22" strokeWidth="2" />
      <text x="30" y="14" fontSize="8" fill="currentColor" stroke="none">30°</text>
    </svg>
  ),
  
  // 2. Stain removal - spray bottle with comb
  stainRemoval: (
    <svg viewBox="0 0 40 40" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8">
      <path d="M10 14 L10 32 L18 32 L18 14 L16 10 L12 10 Z" />
      <line x1="10" y1="18" x2="18" y2="18" />
      <path d="M24 12 L24 30" />
      <path d="M28 12 L28 30" />
      <path d="M32 12 L32 30" />
      <path d="M22 8 L34 8 L34 12 L22 12 Z" />
    </svg>
  ),
  
  // 3. Soap/Shampoo - soap bubbles
  soap: (
    <svg viewBox="0 0 40 40" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8">
      <rect x="8" y="16" width="16" height="18" rx="2" />
      <path d="M12 16 L12 12 C12 8 20 8 20 12 L20 16" />
      <circle cx="28" cy="10" r="3" />
      <circle cx="34" cy="14" r="2" />
      <circle cx="30" cy="18" r="2.5" />
      <circle cx="26" cy="22" r="1.5" />
    </svg>
  ),
  
  // 4. Soak - clothes in water with 20min
  soak: (
    <svg viewBox="0 0 40 40" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8">
      <ellipse cx="20" cy="28" rx="14" ry="6" />
      <path d="M8 20 L8 28" />
      <path d="M32 20 L32 28" />
      <path d="M12 12 L16 20 L24 20 L28 12" />
      <path d="M16 8 L24 8" />
      <circle cx="32" cy="10" r="6" fill="none" />
      <text x="29" y="12" fontSize="6" fill="currentColor" stroke="none">20</text>
    </svg>
  ),
  
  // 5. Wash gently - no twist symbol
  noTwist: (
    <svg viewBox="0 0 40 40" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8">
      <path d="M10 20 C10 12, 20 8, 20 16 C20 8, 30 12, 30 20" />
      <path d="M10 24 C10 32, 20 36, 20 28 C20 36, 30 32, 30 24" />
      <line x1="6" y1="6" x2="34" y2="34" strokeWidth="2" stroke="#dc2626" />
    </svg>
  ),
  
  // 6. Flat dry - towel with clothes
  flatDry: (
    <svg viewBox="0 0 40 40" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8">
      <rect x="4" y="22" width="32" height="12" rx="1" />
      <path d="M10 22 L10 14 L16 10 L24 10 L30 14 L30 22" />
      <line x1="16" y1="10" x2="16" y2="6" />
      <line x1="24" y1="10" x2="24" y2="6" />
    </svg>
  ),
  
  // 7. Steam iron
  steamIron: (
    <svg viewBox="0 0 40 40" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8">
      <path d="M8 28 L32 28 L36 20 L30 12 L10 12 L4 20 Z" />
      <line x1="12" y1="20" x2="28" y2="20" />
      <path d="M14 32 C14 30, 16 30, 16 32" />
      <path d="M20 32 C20 30, 22 30, 22 32" />
      <path d="M26 32 C26 30, 28 30, 28 32" />
    </svg>
  ),
  
  // 8. Storage - folded clothes in bag
  storage: (
    <svg viewBox="0 0 40 40" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8">
      <rect x="8" y="12" width="24" height="22" rx="2" />
      <path d="M12 12 L12 8 L28 8 L28 12" />
      <line x1="12" y1="20" x2="28" y2="20" />
      <line x1="12" y1="26" x2="28" y2="26" />
      <line x1="20" y1="12" x2="20" y2="8" />
    </svg>
  ),
};

const defaultCareSteps = [
  {
    icon: 'temperature',
    title: 'Water Temperature',
    text: 'The water temperature must be consistent for both washing and rinsing and it should be warm but not hot. Do not wash it in water that is warmer than 30 degrees.',
  },
  {
    icon: 'stainRemoval',
    title: 'Stain Removal',
    text: 'Before washing, spray warmer water with liquid soap and gently wash the stain by hand.',
  },
  {
    icon: 'soap',
    title: 'Mild Soap',
    text: 'Add mild liquid soap or shampoo for washing wool and cashmere products to the water and thoroughly dissolve. Do not use powder detergent under any circumstances.',
  },
  {
    icon: 'soak',
    title: 'Soak',
    text: 'Turn the clothes to be washed inside out and soak them in warm water for about 20 minutes.',
  },
  {
    icon: 'noTwist',
    title: 'Wash Gently',
    text: 'Wash gently without twisting or rubbing. Then rinse thoroughly with clean water and gently squeeze out the water.',
  },
  {
    icon: 'flatDry',
    title: 'Flat Dry',
    text: 'In order not to stretch, lay a towel that absorbs water well on a flat surface and spread your clothes and accessories on it to dry.',
  },
  {
    icon: 'steamIron',
    title: 'Steam Iron',
    text: 'Steam iron the clothes while they are slightly damp.',
  },
  {
    icon: 'storage',
    title: 'Storage',
    text: 'Before storing natural animal fiber products and clothes for a long time, it is recommended to wash them, fold them, and store them in well-sealed bag. If stored on a hanger, it will stretch and lose its shape.',
  },
];

export default function CareInstructions({ customInstructions }) {
  // If custom instructions provided, show them as simple text
  if (customInstructions && customInstructions.trim()) {
    return (
      <div className="text-gray-600 space-y-4">
        <p className="font-medium text-gray-800">Dry cleaning recommended.</p>
        <p className="leading-relaxed">{customInstructions}</p>
      </div>
    );
  }

  // Default care instructions with icons
  return (
    <div className="space-y-4">
      {/* Header */}
      <p className="font-medium text-gray-800">
        Dry cleaning recommended.
      </p>
      <p className="text-gray-600 text-sm leading-relaxed">
        Should you prefer handwashing your knitwear, you can take these steps to keep your clothes looking like new and extend their life.
      </p>

      {/* Steps - 2 columns */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        {defaultCareSteps.map((step, index) => (
          <div key={index} className="flex gap-3 items-start">
            {/* Icon */}
            <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-gray-50 flex items-center justify-center text-gray-600">
              {Icons[step.icon]}
            </div>
            
            {/* Text */}
            <div className="flex-1 min-w-0">
              <p className="text-gray-600 text-sm leading-relaxed">
                <span className="font-medium text-gray-800">{index + 1}. </span>
                {step.text}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Yak icon at bottom */}
      <div className="flex justify-end pt-4">
        <svg viewBox="0 0 40 40" className="w-10 h-10 text-gray-300">
          <path 
            fill="currentColor" 
            d="M20 8c-4 0-8 2-10 5-1 2-2 4-2 7 0 4 2 7 5 9l-3 5h4l2-3c1 0 3 1 4 1s3-1 4-1l2 3h4l-3-5c3-2 5-5 5-9 0-3-1-5-2-7-2-3-6-5-10-5zm-6 10c1 0 2 1 2 2s-1 2-2 2-2-1-2-2 1-2 2-2zm12 0c1 0 2 1 2 2s-1 2-2 2-2-1-2-2 1-2 2-2zm-6 8c-2 0-4-1-4-2h8c0 1-2 2-4 2z"
          />
        </svg>
      </div>
    </div>
  );
}